import { AdminDashboard } from "@/components/admin/admin-dashboard"

export default function AdminPage() {
  return <AdminDashboard />
}
